<template>
    <set-azure-cme-credentials-dialog
        :value="value"
        @input="$emit('input', $event)"
        :loading="$wait.is('creatingAzureCmeAccount')"
    >
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #actions="{ form, formId, isValid, clear, close }">
            <post-cloud-account-button
                :value="{ ...form, Type: 'AzureCme' }"
                :clear="clear"
                :valid="isValid"
                :form="formId"
                v-wait-while="'creatingAzureCmeAccount'"
                @http2xx="close().then(() => $emit('http2xx', $event))"
            ></post-cloud-account-button>
        </template>
    </set-azure-cme-credentials-dialog>
</template>

<script>
import SetAzureCmeCredentialsDialog from '@/components/Settings.CloudAccounts/Azure/SetAzureCmeCredentialsDialog';
import PostCloudAccountButton from '@/components/Settings.CloudAccounts/PostCloudAccountButton';
export default {
    components: { SetAzureCmeCredentialsDialog, PostCloudAccountButton },
    props: {
        value: Boolean,
    },
};
</script>